import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import FlatButton from '../../../../tc-ui/flat-button-with-loader';
import SingleAllocation from './single-allocation-node';
import SeasonalSections from '../../../generic-components/seasonal-sections/seasonal-sections';
import DateUtils from '../../../../../utils/date-utils';
import { any, propOr, curry, concat } from 'ramda';
import SyncSectionCheckbox from '../sync-section-checkbox';

const ProductCodeAllocation = ({
  contractingPeriod,
  onRequestClose,
  onTextFieldChangeWithKeyPath,
  addOneElementWithKeyPath,
  deleteOneElementWithKeyPath,
  existingSeasons,
  contractId,
  productId,
  saveProductInfoChanges,
  data,
  saving,
  syncedSections,
  }) => {
  const contentsData = propOr([], 'allocation', data);
  const allDateRanges = DateUtils.getFlattenedUnEmptyDates(contentsData);
  const seasonCovered = DateUtils.seasonCovered(allDateRanges, contractingPeriod);
  const emptyInitialContent = { allotments: [{}] };
  const onFieldChange = curry((extraPaths, value) => onTextFieldChangeWithKeyPath({ keyPath: concat(['data', 'allocation'], extraPaths), value }));
  const onVaryBySeasonChange = value => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'varyBySeason'], value });
  const singleAllocationActions = {
    onTextFieldChangeWithKeyPath: ({ keyPath, value }) => onTextFieldChangeWithKeyPath({ keyPath: concat(['data', 'allocation'], keyPath), value }),
    addOneElementWithKeyPath: ({ keyPath, element }) => addOneElementWithKeyPath({ keyPath: concat(['data', 'allocation'], keyPath), element }),
    deleteOneElementWithKeyPath: ({ keyPath }) => deleteOneElementWithKeyPath({ keyPath: concat(['data', 'allocation'], keyPath) }),
  };

  return (
    <div>
      <SeasonalSections
        name="allocations"
        seasons={existingSeasons}
        contractingPeriod={contractingPeriod}
        varyBySeason={data.varyBySeason}
        useSeasons={data.varyBySeason}
        contentsData={contentsData}
        emptyInitialContent={emptyInitialContent}
        onFieldChange={onFieldChange}
        contentActions={singleAllocationActions}
        ContentNode={SingleAllocation}
        onVaryBySeasonChange={onVaryBySeasonChange}
      />
      <br />
      <div className="flex-tc-sb" style={{ paddingLeft: '20px' }}>
        {
          Boolean(!data.varyBySeason || syncedSections.indexOf('seasons') > -1) ? (
            <SyncSectionCheckbox
              label="Sync Allocation to Other Products"
              style={{ width: '350px' }}
              sectionInEdit="allocation"
            />
          ) : <div>Syncing is disabled because seasons aren't synced.</div>
        }
        <div className="flex-center">
          <FlatButton
            label="Cancel"
            hoverColor="none"
            labelStyle={{ fontWeight: '600', marginRight: '15px' }}
            primary
            onTouchTap={onRequestClose}
          /> &nbsp;&nbsp;
          <FlatButton
            label="Save"
            loader={saving}
            hoverColor="none"
            disabled={any(content => {
              if (!content.allocationType) return true;
              if (content.allocationType === 'allotment') return content.allotments.some(allotment => !(allotment.releaseBackDays && allotment.numberOfRooms));
              return false;
            }, contentsData) || !seasonCovered}
            labelStyle={{ fontWeight: '600' }}
            onTouchTap={() => saveProductInfoChanges({ contractId, productId, data, updateType: 'SAVE_PRODUCT_CODE_ALLOCATION' })}
            secondary
          />
        </div>
      </div>
    </div>
  );
};

ProductCodeAllocation.propTypes = {
  onRequestClose: PropTypes.func,
  contractId: PropTypes.string,
  productId: PropTypes.string,
  data: PropTypes.object,
  saveProductInfoChanges: PropTypes.func,
  onTextFieldChange: PropTypes.func,
  saving: PropTypes.bool,
  syncedSections: PropTypes.array,
};


const mapStateToProps = ({ contracting }) => ({
  syncedSections: contracting.contractActivitiesProducts.getIn(['leftNav', 'syncedSections'])
    ? contracting.contractActivitiesProducts.getIn(['leftNav', 'syncedSections']).toJS()
    : [],
});
export default connect(mapStateToProps)(ProductCodeAllocation);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/allocation/allocation.jsx